export const BASE_URLS = {
  BASE_URL: process.env.REACT_APP_API_URL || "/api/",
  // BASE_URL: "http://localhost:3000/",
};
export const API_URLS = {
  DELETE_ATTENDANCE: BASE_URLS.BASE_URL + "employee-attendance/delete",
  GET_LOGIN: BASE_URLS.BASE_URL + "auth/admin-login",
  LOGIN_DATA: BASE_URLS.BASE_URL + "employees/login-data",
  LOGOUT: BASE_URLS.BASE_URL + "auth/logout",
  OTP_HISTORY: BASE_URLS.BASE_URL + "otp-logs/find-all",
  NOC_SAP_LOGS: BASE_URLS.BASE_URL + "noc-sap-apis-logs/find-all",
  AUDIT_LOGS: BASE_URLS.BASE_URL + "audit-logs/find-all",
  ADMIN_ACTIVITY_LOGS: BASE_URLS.BASE_URL + "audit-logs/admin-activity-logs",
  HRMS_API_LOGS: BASE_URLS.BASE_URL + "hrms-api-logs/find-all",

  TEST_SMS_SETTINGS: BASE_URLS.BASE_URL + "setting-test/test-sms-settings",
  TEST_SMTP_SETTINGS: BASE_URLS.BASE_URL + "setting-test/test-smtp-settings",
  TEST_STORAGE_SETTINGS:
    BASE_URLS.BASE_URL + "setting-test/test-storage-settings",

  UPDATE_ADMIN_SETTING: BASE_URLS.BASE_URL + "website-setting/upsert",
  GET_ADMIN_SETTING: BASE_URLS.BASE_URL + "website-setting/get-settings",

  APPLICATION_MODULES: {
    LIST: BASE_URLS.BASE_URL + "application-modules/list",
    CREATE: BASE_URLS.BASE_URL + "application-modules/create",
    UPDATE: BASE_URLS.BASE_URL + "application-modules/update",
    DELETE: BASE_URLS.BASE_URL + "application-modules/delete",
  },

  OFFICE_LOCATION: {
    FIND_ALL: BASE_URLS.BASE_URL + "office-locations/find-all",
    ADD: BASE_URLS.BASE_URL + "office-locations/create",
    UPDATE: BASE_URLS.BASE_URL + "office-locations/update",
    DELETE: BASE_URLS.BASE_URL + "office-locations/delete",
    FIND_BY_ID: BASE_URLS.BASE_URL + "office-locations/find-one",
    CHANGE_STATUS: BASE_URLS.BASE_URL + "office-locations/update-status",
  },

  NOC: {
    // Outside Job endpoints
    OUTSIDE_JOB_NATURE: BASE_URLS.BASE_URL + "masters/outside-job-nature",
    FIND_ALL_OUTJOB_REQUESTS:
      BASE_URLS.BASE_URL + "noc/find-all-noc-outjob-requests",
    FIND_ONE_OUTJOB_REQUEST:
      BASE_URLS.BASE_URL + "noc/noc-outjob-request-by-id",
    CREATE_OUTJOB_REQUEST:
      BASE_URLS.BASE_URL + "noc/create-noc-outjob-requests",
    DELETE_OUTJOB_REQUEST: BASE_URLS.BASE_URL + "noc/delete",
    APPROVE_REJECT_OUTSIDE_JOB: BASE_URLS.BASE_URL + "noc/approve_reject_action",
    GET_EMPLOYEE_EDUCATION: BASE_URLS.BASE_URL + "noc/get-employee-education",

    // Chat endpoints
    SEND_CHAT_MESSAGE: BASE_URLS.BASE_URL + "noc/chat/send-message",
    GET_CHAT_MESSAGES: BASE_URLS.BASE_URL + "noc/chat/get-messages",
    GET_CHAT_ATTACHMENTS: BASE_URLS.BASE_URL + "noc/chat/get-attachments",
    GET_UNREAD_COUNT: BASE_URLS.BASE_URL + "noc/chat/unread-count",
    PROFILE_IMAGE: BASE_URLS.BASE_URL + "noc/chat/profile-image/",

    // Ex-India (Foreign Visit) endpoints
    FIND_ALL_EX_INDIA_REQUESTS:
      BASE_URLS.BASE_URL + "noc-ex-india/find-all-ex-india-req",
    CREATE_EX_INDIA_REQUEST:
      BASE_URLS.BASE_URL + "noc-ex-india/create-or-update",
    FIND_ONE_EX_INDIA_REQUEST: BASE_URLS.BASE_URL + "noc-ex-india/find-one",
    DELETE_EX_INDIA_REQUEST: BASE_URLS.BASE_URL + "noc-ex-india/delete",
    APPROVE_REJECT_EX_INDIA:
      BASE_URLS.BASE_URL + "noc-ex-india/approve_reject_action",
    SAP_MASTER_NOC_TRAVEL_LIST:
      BASE_URLS.BASE_URL + "noc-ex-india/sap-master-noc-travel-list",
    SAP_MASTER_STAY_LIST:
      BASE_URLS.BASE_URL + "noc-ex-india/sap-master-stay-list",

    // Passport/Visa endpoints
    FIND_ALL_PASSPORT_VISA: BASE_URLS.BASE_URL + "noc-visa-passport/find-all",
    FIND_ONE_PASSPORT_VISA: BASE_URLS.BASE_URL + "noc-visa-passport/find-one",
    CREATE_OR_UPDATE_PASSPORT_VISA:
      BASE_URLS.BASE_URL + "noc-visa-passport/create-or-update",
    DELETE_PASSPORT_VISA: BASE_URLS.BASE_URL + "noc-visa-passport/delete",
    APPROVE_REJECT_PASSPORT_VISA:
      BASE_URLS.BASE_URL + "noc-visa-passport/approve_reject_action",

    // Higher Education endpoints
    FIND_ALL_HIGHER_EDUCATION:
      BASE_URLS.BASE_URL + "noc-higherstudies/find-all",
    FIND_ONE_HIGHER_EDUCATION:
      BASE_URLS.BASE_URL + "noc-higherstudies/find-one",
    CREATE_OR_UPDATE_HIGHER_EDUCATION:
      BASE_URLS.BASE_URL + "noc-higherstudies/create-or-update",
    DELETE_HIGHER_EDUCATION: BASE_URLS.BASE_URL + "noc-higherstudies/delete",
    APPROVE_REJECT_HIGHER_EDUCATION:
      BASE_URLS.BASE_URL + "noc-higherstudies/approve_reject_action",

    // Online Courses endpoints
    FIND_ALL_ONLINE_COURSES: BASE_URLS.BASE_URL + "noc-onlinecourses/find-all",
    FIND_ONE_ONLINE_COURSE: BASE_URLS.BASE_URL + "noc-onlinecourses/find-one",
    CREATE_OR_UPDATE_ONLINE_COURSE:
      BASE_URLS.BASE_URL + "noc-onlinecourses/create-or-update",
    DELETE_ONLINE_COURSE: BASE_URLS.BASE_URL + "noc-onlinecourses/delete",
    APPROVE_REJECT_ONLINE_COURSE:
      BASE_URLS.BASE_URL + "noc-onlinecourses/approve_reject_action",

    // Download Digital NOC endpoints (all 5 NOC modules)
    OUTSIDE_JOB_DOWNLOAD: BASE_URLS.BASE_URL + "noc-common/noc-outjob-download",
    EX_INDIA_DOWNLOAD: BASE_URLS.BASE_URL + "noc-common/noc-outjob-download",
    HIGHER_EDUCATION_DOWNLOAD: BASE_URLS.BASE_URL + "noc-common/noc-outjob-download",
    PASSPORT_VISA_DOWNLOAD: BASE_URLS.BASE_URL + "noc-common/noc-outjob-download",
    ONLINE_COURSE_DOWNLOAD: BASE_URLS.BASE_URL + "noc-common/noc-outjob-download",
    DOWNLOAD_DOC: BASE_URLS.BASE_URL + "noc-common/noc-outjob-download",
  },

  NOC_REIMBURSEMENT: {
    REQUEST_TYPES:
      BASE_URLS.BASE_URL + "noc-reimbursement/reimbursement-request-types",
    DOCUMENT_TYPES:
      BASE_URLS.BASE_URL + "noc-reimbursement/reimbursement-document-types",
    FIND_ALL: BASE_URLS.BASE_URL + "noc-reimbursement/find-all",
    FIND_ONE: BASE_URLS.BASE_URL + "noc-reimbursement/find-one",
    CREATE_OR_UPDATE: BASE_URLS.BASE_URL + "noc-reimbursement/create-or-update",
    DELETE: BASE_URLS.BASE_URL + "noc-reimbursement/delete",
    APPROVE_REJECT:
      BASE_URLS.BASE_URL + "noc-reimbursement/approve_reject_action",
    SYNC: BASE_URLS.BASE_URL + "noc-reimbursement/sync-data",
  },

  AWS_BUCKET: {
    UPLOAD_FILE: BASE_URLS.BASE_URL + "aws-bucket/upload-file",
    DELETE_FILE: BASE_URLS.BASE_URL + "aws-bucket/delete-file",
    GET_PRESIGNED_URL: BASE_URLS.BASE_URL + "aws-bucket/get-presigned-url",
  },

  MASTER_BEACON: {
    FIND_ALL: BASE_URLS.BASE_URL + "master-beacon/list",
    ADD: BASE_URLS.BASE_URL + "master-beacon/add",
    UPDATE: BASE_URLS.BASE_URL + "master-beacon/edit",
    DELETE: BASE_URLS.BASE_URL + "master-beacon/delete",
    FIND_BY_ID: BASE_URLS.BASE_URL + "master-beacon/details",
    CHANGE_STATUS: BASE_URLS.BASE_URL + "master-beacon/change-status",
    ASSIGN_MASTER_BEACON:
      BASE_URLS.BASE_URL + "master-beacon/assign-master-beacon",
    EMPLOYEE_BEACON_ASSIGNMENT_LIST:
      BASE_URLS.BASE_URL + "employee-becon-assignment/list",
  },

  EMPLOYEES: {
    EXPORT_CSV: BASE_URLS.BASE_URL + "employees/export-csv",
    SYNC_FROM_SAP:
      BASE_URLS.BASE_URL +
      "sap-update-requests-get-from-sap/get-employee-details",
    FIND_ALL: BASE_URLS.BASE_URL + "employees/find-all",
    FIND_ALL_EMPLOYEES: BASE_URLS.BASE_URL + "employee-attendance/find-all",
    FIND_EMPLOYEE_REGULARIZE:
      BASE_URLS.BASE_URL + "employee-attendance/my-attendance",
    FIND_DAILY_EMPLOYEE_REGULARIZE:
      BASE_URLS.BASE_URL + "employee-attendance/my-daily-attendance",
    My_PROFILE: BASE_URLS.BASE_URL + "employees/my-profile",
    PROFILE_REASONS: BASE_URLS.BASE_URL + "employees/get-verification",
    UPDATE_PROFILE_REASONS:
      BASE_URLS.BASE_URL + "employees/update-verification-status",

    EMPLOYEE_PROFILE: BASE_URLS.BASE_URL + "employees/employee-profile",
    UPLOAD_PROFILE_PICTURE: BASE_URLS.BASE_URL + "employees/update-profile-picture",
    PROFILE_PICTURE_HISTORY: BASE_URLS.BASE_URL + "employees/find-emp-photo-history",
    ASSIGN_OFFICE: BASE_URLS.BASE_URL + "employees/assign-office-location",
    VERIFICATION_LIST: BASE_URLS.BASE_URL + "attendance-verifications/find-all",
    FIND_SETTING: BASE_URLS.BASE_URL + "employee-settings/find-all",
    UPDATE_SETTING: BASE_URLS.BASE_URL + "employee-settings/update",
    VERIFICATION_LIST_HISTORY:
      BASE_URLS.BASE_URL + "attendance-verifications/history",
    ADD_UPDATE_ADDRESS: BASE_URLS.BASE_URL + "employees/update-address",
    UPDATE_VERIFICATION_STATUS:
      BASE_URLS.BASE_URL + "attendance-verifications/update-verification",
    BULK_UPDATE_VERIFICATION:
      BASE_URLS.BASE_URL + "attendance-verifications/bulk-update-verification",
    GET_DOC_URL: BASE_URLS.BASE_URL + "attendance-verifications/document-url",
    GET_ATTENDANCE_DOC_URL:
      BASE_URLS.BASE_URL + "employee-attendance/document-url",
    UPDATE_ATTENDANCE:
      BASE_URLS.BASE_URL + "employee-attendance/update-attendance",
    BULK_UPDATE_ATTENDANCE:
      BASE_URLS.BASE_URL + "employee-attendance/bulk-update-attendance",

    REPORTING_EMPLOYEES: BASE_URLS.BASE_URL + "reporting-employees/find-all",
    ASSIGN_ROLE: BASE_URLS.BASE_URL + "roles/assign-role",
    UPDATE_EMERGENCY_CONTACT:
      BASE_URLS.BASE_URL + "employees/update-emergency-contact",
    EMPLOYEE_WORK_SCHEDULE:
      BASE_URLS.BASE_URL + "work-schedule/employee-work-schedule",
    TOGGLE_LOGIN_ON_OFF: BASE_URLS.BASE_URL + "employees/toggle-login-on-off",
    UPDATE_LOGIN_ON_OFF: BASE_URLS.BASE_URL + "employees/update-login-on-off",
    EMPLOYEE_CHANGE_PASSWORD:
      BASE_URLS.BASE_URL + "auth/change-employee-password",
    RESET_LOGIN_FAILED: BASE_URLS.BASE_URL + "employees/reset-login-failed",
  },

  ATTENDANCE: {
    FIND_ALL: BASE_URLS.BASE_URL + "employee-attendance/pending-approvals",
    TEAM_DAILY_ATTENDANCE:
      BASE_URLS.BASE_URL + "employee-attendance/team-daily-attendance",
    SUMMARY: BASE_URLS.BASE_URL + "employee-attendance/find-all",
    MY_ATTENDANCE_SUMMARY:
      BASE_URLS.BASE_URL + "employee-attendance/my-attendance",
    BULK_UPDATE:
      BASE_URLS.BASE_URL + "employee-attendance/bulk-update-attendance",
  },

  ROLE_PERMISSIONS: {
    ADD_NEW_ROLE: BASE_URLS.BASE_URL + "roles/add",
    UPDATE_ROLE: BASE_URLS.BASE_URL + "roles/update",
    ROLES_LIST: BASE_URLS.BASE_URL + "roles/find-all",

    ROLES_PERMISSION: BASE_URLS.BASE_URL + "roles/permissions",
    ASSIGN_PERMISSION: BASE_URLS.BASE_URL + "roles/assign-permission",
    FIND_ALL_DESIGNATIONS: BASE_URLS.BASE_URL + "masters/find-all-designations",
    FIND_ALL_DEPARTMENTS: BASE_URLS.BASE_URL + "masters/find-all-departments",
    FIND_ALL_ADDRESS_TYPES: BASE_URLS.BASE_URL + "masters/find-all-address-types",
    FIND_ALL_REGIONS_SAP: BASE_URLS.BASE_URL + "masters/find-all-regions-sap",
    WORK_SCHEDULE:
      BASE_URLS.BASE_URL + "work-schedule/find-all-master-work-schedule",

    EMP_PERMISSION: BASE_URLS.BASE_URL + "roles/emp-permissions",
    ASSIGN_EMP_PERMISSION: BASE_URLS.BASE_URL + "roles/assign-emp-permission",
  },

  EMPLOYEE_AUTH: {
    GET_LOGIN: BASE_URLS.BASE_URL + "auth/login",
    VERIFY_LOGIN_OTP: BASE_URLS.BASE_URL + "auth/verify-login-otp",
    VERIFY_OTP: BASE_URLS.BASE_URL + "auth/verify-otp",
    RESEND_OTP: BASE_URLS.BASE_URL + "auth/resend-otp",
    FORGOT_PASSWORD: BASE_URLS.BASE_URL + "auth/forgot-password",
    RESET_PASSWORD: BASE_URLS.BASE_URL + "auth/reset-password",
    CHANGE_PASSWORD: BASE_URLS.BASE_URL + "auth/change-password",
    UPDATE_CONTACT: BASE_URLS.BASE_URL + "auth/change-phone-number",
    VERIFY_CONTACT: BASE_URLS.BASE_URL + "auth/verify-phone-number",
  },

  POLICE_VERIFICATION: {
    STATUS: BASE_URLS.BASE_URL + "sap-police-verification/status",
  },

  ADMIN_AUTH: {
    GET_LOGIN: BASE_URLS.BASE_URL + "admin-auth/login",
    VERIFY_LOGIN_OTP: BASE_URLS.BASE_URL + "admin-auth/verify-login-otp",
    VERIFY_OTP: BASE_URLS.BASE_URL + "admin-auth/verify-otp",
    RESEND_OTP: BASE_URLS.BASE_URL + "admin-auth/resend-otp",
    FORGOT_PASSWORD: BASE_URLS.BASE_URL + "admin-auth/forgot-password",
    RESET_PASSWORD: BASE_URLS.BASE_URL + "admin-auth/reset-password",
    CHANGE_PASSWORD: BASE_URLS.BASE_URL + "admin-auth/change-password",
  },

  WORK_SHIFT: {
    FIND_ALL: BASE_URLS.BASE_URL + "work-shifts/find-all",
    ADD_NEW: BASE_URLS.BASE_URL + "work-shifts/add",
    UPDATE: BASE_URLS.BASE_URL + "work-shifts/update",
    SHIFT_APPROVALS: BASE_URLS.BASE_URL + "work-shifts/pending-approvals",
    CHANGE_STATUS: BASE_URLS.BASE_URL + "work-shifts/change-status",
    ASSIGN_SHIFT: BASE_URLS.BASE_URL + "work-shifts/assign-shift",
    EMPLOYEE_SHIFT_HISTORY:
      BASE_URLS.BASE_URL + "work-shifts/employee-shift-history",
  },

  NOTIFICATIONS: {
    NOTIFICATIONS_COUNT:
      BASE_URLS.BASE_URL + "notification-history/notification-count",
    NOTIFICATIONS_COUNT_BY_TYPE:
      BASE_URLS.BASE_URL + "notification-history/notification-count-by-type",
    NOTIFICATIONS_BY_STATUS:
      BASE_URLS.BASE_URL + "notification-history/notification-by-staus",
  },

  LEAVE: {
    LEAVE_TYPES: BASE_URLS.BASE_URL + "masters/find-all-master-leave-type",
    CREATE_LEAVE_REQUEST: BASE_URLS.BASE_URL + "leave/create-leave-request",
    EMP_LEAVE_ABSENCE_TYPE: BASE_URLS.BASE_URL + "leave/emp-leave-absence-type",
    GET_LEAVE_REQUEST_BY_ID: BASE_URLS.BASE_URL + "leave/get-leave-request-by-id",
    SYNC_EMPLOYEE_LEAVES: BASE_URLS.BASE_URL + "leave/sync-employee-leaves",
    UPLOAD_LEAVE_ATTACHMENT: BASE_URLS.BASE_URL + "leave/upload-leave-attachment",
    EMP_LEAVE_CALENDAR: BASE_URLS.BASE_URL + "leave/emp-leave-calendar",
    GET_DROP_DOWN: BASE_URLS.BASE_URL + "leave/get-drop-down",
    GET_ALL_LEAVES: BASE_URLS.BASE_URL + "leave/get-all-leaves",
    ALL_EMPLOYEE_LEAVES: BASE_URLS.BASE_URL + "leave/all-employee-leaves",
    TEAM_LEAVE_CALENDAR: BASE_URLS.BASE_URL + "leave/team-calendar",
    EMP_LEAVE_FILE_ATTACHMENT: BASE_URLS.BASE_URL + "leave/emp-leave-file-attachment",
    EMP_LEAVE_TIME_ACCOUNTS: BASE_URLS.BASE_URL + "leave/emp-leave-time-accounts",
  },

  TAX_CARD: {
    FETCH: BASE_URLS.BASE_URL + "tax-card/fetch",
    SIMPLIFIER_COMPARE: BASE_URLS.BASE_URL + "tax-card/simplifier/compare/fetch",
  },

  TAX_SIMPLIFIER: {
    FETCH: BASE_URLS.BASE_URL + "tax-simplifier/fetch",
    EDIT_FETCH: BASE_URLS.BASE_URL + "tax-simplifier/edit/fetch",
    EDIT_SAVE: BASE_URLS.BASE_URL + "tax-simplifier/edit/save",
  },

  LOAN_SURETY: {
    LOAN_TYPES: BASE_URLS.BASE_URL + "sap-loan-surety/loan-types",
    RECEIVED: BASE_URLS.BASE_URL + "sap-loan-surety/received-employees",
    GIVEN: BASE_URLS.BASE_URL + "sap-loan-surety/given-sureties",
  },

  ANNUAL_NPS_PF: {
    NPS_DEDUCTION_MASTER: BASE_URLS.BASE_URL + "annual-nps-pf/nps/get-deduction-master",
    NPS_GET_REQUESTS: BASE_URLS.BASE_URL + "annual-nps-pf/nps/get-requests",
    PF_GET_DETAILS: BASE_URLS.BASE_URL + "annual-nps-pf/pf/get-pf-details",
  },

  OUTSIDE_JOB_NATURE: {
    FIND_ALL: BASE_URLS.BASE_URL + "masters/outside-job-nature-of-duty",
  },

  HOLIDAY: {
    LIST: BASE_URLS.BASE_URL + "masters/find-all-master-holiday-calendar",
  },

  USERS: {
    LIST: BASE_URLS.BASE_URL + "users/find-all-Users",
    ADD: BASE_URLS.BASE_URL + "users/create-user",
  },

  LANGUAGES: {
    GET_LANGUAGES: BASE_URLS.BASE_URL + "languages/list",
    UPDATE_LANGUAGE_STATUS: BASE_URLS.BASE_URL + "languages/toggle-status",
    GET_LANGUAGE_GROUPS: BASE_URLS.BASE_URL + "languages/groups/list",
    ADD_LANGUAGE_GROUP: BASE_URLS.BASE_URL + "languages/groups",
    GET_LANGUAGE_TRANSLATIONS:
      BASE_URLS.BASE_URL + "languages/translations/list",

    // Additional endpoints for complete CRUD operations
    ADD_LANGUAGE: BASE_URLS.BASE_URL + "languages/add-update-lang",
    UPDATE_LANGUAGE: BASE_URLS.BASE_URL + "languages/update",
    DELETE_LANGUAGE: BASE_URLS.BASE_URL + "languages/delete",
    PUBLISH_TRANSLATION: BASE_URLS.BASE_URL + "languages/publish-new-version",

    UPDATE_LANGUAGE_GROUP: BASE_URLS.BASE_URL + "languages/groups/update",
    DELETE_LANGUAGE_GROUP: BASE_URLS.BASE_URL + "languages/groups/delete",

    ADD_LANGUAGE_TRANSLATION: BASE_URLS.BASE_URL + "languages/translations",
    UPDATE_LANGUAGE_TRANSLATION:
      BASE_URLS.BASE_URL + "languages/translations/update",
    DELETE_LANGUAGE_TRANSLATION:
      BASE_URLS.BASE_URL + "languages/translations/delete",
    BULK_UPDATE_TRANSLATIONS:
      BASE_URLS.BASE_URL + "languages/translations/bulk-update",

    // Language Versions endpoints
    GET_LANGUAGE_VERSIONS: BASE_URLS.BASE_URL + "languages/version/list",
    ADD_LANGUAGE_VERSION: BASE_URLS.BASE_URL + "languages/version",
    UPDATE_LANGUAGE_VERSION: BASE_URLS.BASE_URL + "languages/version/update",
    DELETE_LANGUAGE_VERSION: BASE_URLS.BASE_URL + "languages/version/delete",
    SET_DEFAULT_VERSION: BASE_URLS.BASE_URL + "languages/version/set-default",
  },

  CHATBOT: {
    // Intent endpoints
    GET_ALL_INTENTS: BASE_URLS.BASE_URL + "chatbot/get-all-intent",
    CREATE_INTENT: BASE_URLS.BASE_URL + "chatbot/create-intent",
    DELETE_INTENT: BASE_URLS.BASE_URL + "chatbot/delete-intent",

    // FAQ Question endpoints
    GET_ALL_FAQ_QUESTIONS: BASE_URLS.BASE_URL + "chatbot/get-all-faq-question",
    CREATE_FAQ_QUESTION: BASE_URLS.BASE_URL + "chatbot/create-faq-question",
    DELETE_FAQ_QUESTION: BASE_URLS.BASE_URL + "chatbot/delete-faq-question",

    // FAQ Answer endpoints
    GET_ALL_FAQ_ANSWERS: BASE_URLS.BASE_URL + "chatbot/get-all-faq-answer",
    CREATE_FAQ_ANSWER: BASE_URLS.BASE_URL + "chatbot/create-faq-answer",
  },

  ANNOUNCEMENTS: {
    UPSERT: BASE_URLS.BASE_URL + "announcement/upsert",
    INSERT: BASE_URLS.BASE_URL + "announcement/create",
    GET_ALL: BASE_URLS.BASE_URL + "announcement/list",
    SAVE_SCHEDULAR: BASE_URLS.BASE_URL + "announcement/save-schedular",
    TOGGLE_FAVOURITE: BASE_URLS.BASE_URL + "announcement/toggle-favourite",
  },

  ERROR_MANAGEMENT: {
    CREATE_GROUP: BASE_URLS.BASE_URL + "error/create-group",
    GET_ALL_GROUPS: BASE_URLS.BASE_URL + "error/get-all-groups",
    CREATE_CODE: BASE_URLS.BASE_URL + "error/create-code",
    GET_ALL_CODES: BASE_URLS.BASE_URL + "error/get-all-error-code",
  },

  // Legacy INTENT - keeping for backwards compatibility
  INTENT: {
    GET_ALL_INTENTS: BASE_URLS.BASE_URL + "chatbot/get-all-intent",
    CREATE_INTENT: BASE_URLS.BASE_URL + "chatbot/create-intent",
  },

  AUTH: {
    LOGIN_LOGS: BASE_URLS.BASE_URL + "auth/login-logs",
  },

  SMS_TEMPLATES: {
    LIST: BASE_URLS.BASE_URL + "sms-templates/list",
    CREATE: BASE_URLS.BASE_URL + "sms-templates/create",
    GET_BY_ID: BASE_URLS.BASE_URL + "sms-templates/get-by-id",
    DELETE: BASE_URLS.BASE_URL + "sms-templates/delete",
  },

  EMAIL_TEMPLATES: {
    LIST: BASE_URLS.BASE_URL + "email-templates/list",
    CREATE: BASE_URLS.BASE_URL + "email-templates/create",
    GET_BY_ID: BASE_URLS.BASE_URL + "email-templates/get-by-id",
    DELETE: BASE_URLS.BASE_URL + "email-templates/delete",
  },
  SAP_MASTER_WORKLIST: {
    FIND_ALL: BASE_URLS.BASE_URL + "sap-master-worklist/find-all",
    GET_NOC_DATA: BASE_URLS.BASE_URL + "sap-master-worklist/get-noc-data",
    GET_NOC_DNAR_DROPDOWN_DATA: BASE_URLS.BASE_URL + "masters/master-dnar-list",
    APPROVE_REJECT_ACTION:
      BASE_URLS.BASE_URL + "sap-master-worklist/approve_reject_action",
    SYNC_CURRENT_DAY: BASE_URLS.BASE_URL + "sap-master-worklist/sync-current-day",
    MODULE_TYPES: BASE_URLS.BASE_URL + "sap-master-worklist/module-types",
  },

  MASTERS: {
    FIND_ALL_NATURES: BASE_URLS.BASE_URL + "masters/find-all-natures",
    FIND_ALL_STAYS: BASE_URLS.BASE_URL + "masters/find-all-stays",
    FIND_ALL_STATUS: BASE_URLS.BASE_URL + "masters/find-all-statuses",
    FIND_ALL_NOC_TRAVEL: BASE_URLS.BASE_URL + "masters/find-all-noc-travel",
    FIND_ALL_MODE_OF_COURSE:
      BASE_URLS.BASE_URL + "masters/find-all-modes-of-course",
    FIND_ALL_DOC_UPLOAD_TYPES:
      BASE_URLS.BASE_URL + "masters/find-all-doc-upload-types",
    FIND_ALL_COURSE_TYPES: BASE_URLS.BASE_URL + "masters/find-all-course-types",
    FIND_ALL_COURSE_CATEGORIES:
      BASE_URLS.BASE_URL + "masters/find-all-course-categories",
    FIND_ALL_CASTE: BASE_URLS.BASE_URL + "masters/find-all-master-caste",
    WING_DESIGNATIONS_DEPARTMENTS:
      BASE_URLS.BASE_URL + "masters/find-all-departments-designations",
    DNAR_LIST: BASE_URLS.BASE_URL + "masters/master-dnar-list",
    COURSE_DEPARTMENT_LIST:
      BASE_URLS.BASE_URL + "masters/noc-course-departments",
    NATURE_OF_DUTY:
      BASE_URLS.BASE_URL + "noc-higherstudies/master-nature-of-duty",
    COURSE_TYPES: BASE_URLS.BASE_URL + "noc-higherstudies/master-course-types",
    MODE_OF_COURSE:
      BASE_URLS.BASE_URL + "noc-higherstudies/master-mode-of-course",
  },

  VPF: {
    FIND_ALL: BASE_URLS.BASE_URL + "vpf-request/find-all",
    CREATE_OR_UPDATE: BASE_URLS.BASE_URL + "vpf-request/create-or-update",
  },

  APPEAL_CONTRIBUTION: {
    FIND_ALL: BASE_URLS.BASE_URL + "sap-appeal-contribution/find-all",
    FIND_ONE: BASE_URLS.BASE_URL + "sap-appeal-contribution/find-one",
    APPEAL_TYPES: BASE_URLS.BASE_URL + "sap-appeal-contribution/appeal-types",
    WILLINGNESS_OPTIONS:
      BASE_URLS.BASE_URL + "sap-appeal-contribution/willingness-options",
    DECEASED_LIST: BASE_URLS.BASE_URL + "sap-appeal-contribution/deceased-list",
    CREATE: BASE_URLS.BASE_URL + "sap-appeal-contribution/create",
    SYNC: BASE_URLS.BASE_URL + "sap-appeal-contribution/sync-by-employee",
  },

  COMMUNITY_HALL: {
    BLOCK_OPTIONS: BASE_URLS.BASE_URL + "sap-community-hall-booking/block-options",
    REQUEST_TYPE_OPTIONS: BASE_URLS.BASE_URL + "sap-community-hall-booking/request-type-options",
    STAFF_QUARTER_OPTIONS: BASE_URLS.BASE_URL + "sap-community-hall-booking/staff-quarter-options",
    CHECK_AMOUNT: BASE_URLS.BASE_URL + "sap-community-hall-booking/check-amount",
    VALIDATE: BASE_URLS.BASE_URL + "sap-community-hall-booking/request/validate",
    CREATE_OR_UPDATE: BASE_URLS.BASE_URL + "sap-community-hall-booking/request/create-or-update",
    FIND_ALL: BASE_URLS.BASE_URL + "sap-community-hall-booking/find-all",
    FIND_ONE: BASE_URLS.BASE_URL + "sap-community-hall-booking/request/find-one",
    APPROVE_REJECT: BASE_URLS.BASE_URL + "sap-community-hall-booking/approve-reject",
    SYNC: BASE_URLS.BASE_URL + "sap-community-hall-booking/sync",
    DISPLAY_SET: BASE_URLS.BASE_URL + "sap-community-hall-booking/display-set",
    DOWNLOAD_APPROVAL_LETTER: BASE_URLS.BASE_URL + "sap-community-hall-booking/download-pdf",
    CANCELLATION_CREATE: BASE_URLS.BASE_URL + "sap-community-hall-booking/cancellation/create",
    CANCELLATION_APPROVE_REJECT:
      BASE_URLS.BASE_URL + "sap-community-hall-booking/cancellation/approve-reject",
  },

  LEAVE_ENCASHMENT: {
    LEAVE_TYPES: BASE_URLS.BASE_URL + "sap-leave-encashment/leave-types",
    METHODS: BASE_URLS.BASE_URL + "sap-leave-encashment/encashment-methods",
    CREATE: BASE_URLS.BASE_URL + "sap-leave-encashment/create-request",
    FIND_ALL: BASE_URLS.BASE_URL + "sap-leave-encashment/find-all",
    TIME_QUOTA: BASE_URLS.BASE_URL + "sap-leave-encashment/time-quota",
    SYNC: BASE_URLS.BASE_URL + "sap-leave-encashment/sync",
    FIND_ONE: BASE_URLS.BASE_URL + "sap-leave-encashment/find-one",
    APPROVER_DETAILS: BASE_URLS.BASE_URL + "sap-leave-encashment/approver-details",
    APPROVE_REJECT: BASE_URLS.BASE_URL + "sap-leave-encashment/approve-reject",
    DELETE: BASE_URLS.BASE_URL + "sap-leave-encashment/delete-request",
    UPDATE: BASE_URLS.BASE_URL + "sap-leave-encashment/update-request",
  },

  ANNUAL_PROPERTY_RETURN: {
    GET: BASE_URLS.BASE_URL + "sap-annual-property-returns/get-details",
    DOWNLOAD: BASE_URLS.BASE_URL + "sap-annual-property-returns/download",
    SAVE: BASE_URLS.BASE_URL + "sap-annual-property-returns/save",
    SYNC: BASE_URLS.BASE_URL + "sap-annual-property-returns/sync",
    GET_NIL_DETAILS: BASE_URLS.BASE_URL + "sap-annual-property-returns/get-nil-details",
  },

  MEDICAL_ATTENDANCE: {
    TYPE_OF_DOCUMENTS: BASE_URLS.BASE_URL + "medical-attendance/type-of-documents",
    APPLICATION_FOR: BASE_URLS.BASE_URL + "medical-attendance/application-for",
    DISEASES: BASE_URLS.BASE_URL + "medical-attendance/diseases",
    HOSPITALS: BASE_URLS.BASE_URL + "medical-attendance/hospitals",
    PATIENT_NAMES: BASE_URLS.BASE_URL + "medical-attendance/patient-names",
    RELATIONSHIPS: BASE_URLS.BASE_URL + "medical-attendance/relationships",
    CREATE_OR_UPDATE: BASE_URLS.BASE_URL + "medical-attendance/request/create-or-update",
    FIND_ALL: BASE_URLS.BASE_URL + "medical-attendance/request/find-all",
    FIND_ONE: BASE_URLS.BASE_URL + "medical-attendance/request/find-one",
    APPROVE_REJECT: BASE_URLS.BASE_URL + "medical-attendance/request/approve_reject_action",
    SYNC: BASE_URLS.BASE_URL + "medical-attendance/sync",
    CHECK_IVF_ELIGIBILITY: BASE_URLS.BASE_URL + "medical-attendance/check-ivf-eligibility",
    DOWNLOAD: BASE_URLS.BASE_URL + "medical-attendance/request/download",
  },

  STAFF_WELFARE: {
    PURPOSES: BASE_URLS.BASE_URL + "staff-welfare-fund/purposes",
    MARRIAGE_GIFT_CLAIMS: BASE_URLS.BASE_URL + "staff-welfare-fund/marriage-gift-claims",
    CHILD_NAMES: BASE_URLS.BASE_URL + "staff-welfare-fund/child-names",
    SPOUSE_NAMES: BASE_URLS.BASE_URL + "staff-welfare-fund/spouse-names",
    SON_NAMES: BASE_URLS.BASE_URL + "staff-welfare-fund/son-names",
    DAUGHTER_NAMES: BASE_URLS.BASE_URL + "staff-welfare-fund/daughter-names",
    CREATE: BASE_URLS.BASE_URL + "staff-welfare-fund/create",
    ALL: BASE_URLS.BASE_URL + "staff-welfare-fund/all",
    SYNC: BASE_URLS.BASE_URL + "staff-welfare-fund/sync",
    FORM_CONFIG: BASE_URLS.BASE_URL + "staff-welfare-fund/form-config",
    DETAILS: BASE_URLS.BASE_URL + "staff-welfare-fund/details",
    APPROVE_REJECT: BASE_URLS.BASE_URL + "staff-welfare-fund/approve_reject_action",
    NO_OF_CHILDREN: BASE_URLS.BASE_URL + "staff-welfare-fund/no-of-children",
    CHILD_CLASSES: BASE_URLS.BASE_URL + "staff-welfare-fund/child-classes",
    ADMISSION_TYPES: BASE_URLS.BASE_URL + "staff-welfare-fund/admission-types",
    PERCENTAGE_MARKS: BASE_URLS.BASE_URL + "staff-welfare-fund/percentage-marks",
    RELATIONSHIPS: BASE_URLS.BASE_URL + "staff-welfare-fund/relationships",
    DISEASES: BASE_URLS.BASE_URL + "staff-welfare-fund/diseases",
    DISABILITY_PERCENTAGES: BASE_URLS.BASE_URL + "staff-welfare-fund/disability-percentages",
    CLAIM_QUARTERS: BASE_URLS.BASE_URL + "staff-welfare-fund/claim-quarters",
    COURSES: BASE_URLS.BASE_URL + "staff-welfare-fund/courses",
    DOCUMENT: BASE_URLS.BASE_URL + "staff-welfare-fund/document",
  },

  COMPREHENSIVE_HEALTH_CHECK: {
    HOSPITALS: BASE_URLS.BASE_URL + "sap-comprehensive-health-check/hospitals",
    CREATE_REQUEST: BASE_URLS.BASE_URL + "sap-comprehensive-health-check/create-request",
    FIND_ALL: BASE_URLS.BASE_URL + "sap-comprehensive-health-check/request/find-all",
    FIND_ONE: BASE_URLS.BASE_URL + "sap-comprehensive-health-check/request/find-one",
    SYNC: BASE_URLS.BASE_URL + "sap-comprehensive-health-check/sync",
    DOWNLOAD: BASE_URLS.BASE_URL + "noc-common/noc-outjob-download",
  },

  PAYSTUB: {
    FIND_ALL: BASE_URLS.BASE_URL + "paystubs/find-all",
    SYNC: BASE_URLS.BASE_URL + "paystubs/sync",
    DOWNLOAD: BASE_URLS.BASE_URL + "paystubs/download",
    DOWNLOAD_HINDI: BASE_URLS.BASE_URL + "paystubs/hindi-download",
    DOWNLOAD_STATEMENT: BASE_URLS.BASE_URL + "paystubs/download-statement",
  },

  reimbursement: {
    FindAllReimbursement:
      BASE_URLS.BASE_URL + "employee-reimbursement/find-all",
    GET_MASTERS:
      BASE_URLS.BASE_URL + "employee-reimbursement/masters",
    GET_REIMBURSEMENT_TYPES:
      BASE_URLS.BASE_URL + "employee-reimbursement/reimbursement-types-by-emp",
    GET_MASTERS_CASCADING:
      BASE_URLS.BASE_URL + "employee-reimbursement/get-masters-cascading",
    GET_LTC_CODE:
      BASE_URLS.BASE_URL + "employee-reimbursement/reimbursement-ltc-block-master",
    GET_CONFIG: BASE_URLS.BASE_URL + "employee-reimbursement/get-config",
    CREATE_OR_UPDATE:
      BASE_URLS.BASE_URL + "employee-reimbursement/create-or-update",
    DELETE: BASE_URLS.BASE_URL + "employee-reimbursement/delete-request",
    APPROVE_REJECT:
      BASE_URLS.BASE_URL + "noc-reimbursement/approve_reject_action",
    SYNC_DATA:
      BASE_URLS.BASE_URL + "employee-reimbursement/sync-data",
    SYNC_ELIGIBILITY:
      BASE_URLS.BASE_URL + "employee-reimbursement/sync-eligibility",
    LTC_ELIGIBILITY:
      BASE_URLS.BASE_URL + "employee-reimbursement/reimbursement-ltc-eligibility",
    REIMBURSEMENT_ELIGIBILITY:
      BASE_URLS.BASE_URL + "employee-reimbursement/reimbursement-eligibility",
    SYNC_MASTERS:
      BASE_URLS.BASE_URL + "employee-reimbursement/sync-masters",
    SYNC_REIMBURSEMENT_REQUEST:
      BASE_URLS.BASE_URL + "employee-reimbursement/sync-reimbursement-request",
    SYNC_REIMBURSEMENT_TYPES:
      BASE_URLS.BASE_URL + "employee-reimbursement/sync-reimbursement-types",
    REIMBURSEMENT_REQUEST_BY_ID:
      BASE_URLS.BASE_URL + "employee-reimbursement/reimbursement-request-by-id",
    DOWNLOAD_REIMBURSEMENT_FORM:
      BASE_URLS.BASE_URL + "employee-reimbursement/download-reimbursement-form",
    SYNC_REIMBURSEMENT_BY_REF:
      BASE_URLS.BASE_URL + "employee-reimbursement/sync-reimbursement-request",
    GET_REIMBURSEMENT_ASSOC_REF:
      BASE_URLS.BASE_URL + "employee-reimbursement/reimbursement-assoc-ref",
  },
  APAR: {
    APPRAISAL_DISPLAY: BASE_URLS.BASE_URL + "appraisal/display",
    APPRAISAL_DOWNLOAD: BASE_URLS.BASE_URL + "appraisal/download",
    APPRAISAL_STATUS: BASE_URLS.BASE_URL + "appraisal/status",
    APPRAISAL_EMPLOYEE_CHANNEL: BASE_URLS.BASE_URL + "appraisal/employee-channel",
  },
  AICHAT: {
    SEND_MESSAGE: BASE_URLS.BASE_URL + "chatbot/v1/chat",
  },
  ID_CARD: {
    FIND_ALL: BASE_URLS.BASE_URL + "id-cards/request/find-all",
    SYNC: BASE_URLS.BASE_URL + "id-cards/sync",
    MASTER: BASE_URLS.BASE_URL + "id-cards/master/find-all",
    UPLOAD_PHOTO: BASE_URLS.BASE_URL + "id-cards/request/upload-photo",
    CREATE: BASE_URLS.BASE_URL + "id-cards/request/create-or-update",
    FIND_ONE: BASE_URLS.BASE_URL + "id-cards/request/find-one",
    DEPENDENT_INCLUSION: BASE_URLS.BASE_URL + "id-cards/request/inclusion-dependent",
    DEPENDENT_DELETION: BASE_URLS.BASE_URL + "id-cards/request/deletion-dependent",
    DETAILS: BASE_URLS.BASE_URL + "id-cards/request/find-one",
    APPROVE_REJECT_ACTION: BASE_URLS.BASE_URL + "id-cards/request/approve_reject_action",
  },
  E_OFFICE: {
    FIND_ALL: BASE_URLS.BASE_URL + "eoffice-requisition/request/find-all",
  },
  E_REQUISITION: {
    FIND_ALL: BASE_URLS.BASE_URL + "e-requisition/request/find-all",
    FIND_ONE: BASE_URLS.BASE_URL + "e-requisition/request/find-one",
    MASTER_FIND_ALL: BASE_URLS.BASE_URL + "e-requisition/master/find-all",
    CREATE_UPDATE: BASE_URLS.BASE_URL + "e-requisition/create-update",
    APPROVE_REJECT: BASE_URLS.BASE_URL + "e-requisition/approve-reject",
    DELETE_DRAFT: BASE_URLS.BASE_URL + "e-requisition/delete-draft",
    SYNC: BASE_URLS.BASE_URL + "e-requisition/sync-user-requests",
  },
  uploadFile: BASE_URLS.BASE_URL + "chatbot/bulk-upload-faq-questions",

  STAFF_QUARTER: {
    PERMISSIONS: BASE_URLS.BASE_URL + "staff-quarters/permissions",
    ADMIN_ROLES_PERMISSIONS: BASE_URLS.BASE_URL + "staff-quarters-inventory/my-role",
    GET_EMPLOYEE_DETAILS: BASE_URLS.BASE_URL + "staff-quarters/employee-details",
    REGISTER: BASE_URLS.BASE_URL + "staff-quarters/register",
    VIEW: BASE_URLS.BASE_URL + "staff-quarters/list-all",
    GET_BY_ID: BASE_URLS.BASE_URL + "staff-quarters/get-by-id",
    APPROVE_REJECT: BASE_URLS.BASE_URL + "staff-quarters/approve-reject",
    GET_REQUESTS_BY_STATUS: BASE_URLS.BASE_URL + "staff-quarters/requests-by-status",
    GET_USER_REQUESTS: BASE_URLS.BASE_URL + "staff-quarters/user-requests",
    CREATE_OCCUPATION: BASE_URLS.BASE_URL + "staff-quarters-occupation/create-occupation",
    LIST_OCCUPATION: BASE_URLS.BASE_URL + "staff-quarters-occupation/list-all",
    WITHDRAW: BASE_URLS.BASE_URL + "staff-quarters-occupation/withdraw",
    GET_WITHDRAWAL_DETAILS: BASE_URLS.BASE_URL + "staff-quarters-occupation/get-withdrawal-details",
    GET_CURRENT_REGISTRATION: BASE_URLS.BASE_URL + "staff-quarters-occupation/get-current-registration",
    GET_CURRENT_REGISTRATION_DETAILS: BASE_URLS.BASE_URL + "staff-quarters-occupation/get-current-registration-details",
    GET_OCCUPATION_DETAILS: BASE_URLS.BASE_URL + "staff-quarters-occupation/get-occupation-details",
    APPROVE_REJECT_OCCUPATION: BASE_URLS.BASE_URL + "staff-quarters-occupation/approve-reject",
    EXTEND_OCCUPATION: BASE_URLS.BASE_URL + "staff-quarters-occupation/occupation-extension",
    GENERATE_DECLARATION_PDF: BASE_URLS.BASE_URL + "staff-quarters-occupation/generate-declaration-pdf",
    GENERATE_OCCUPATION_REPORT_PDF: BASE_URLS.BASE_URL + "staff-quarters-occupation/generate-occupation-report-pdf",
    CREATE_VACATION: BASE_URLS.BASE_URL + "staff-quarter-vacation/create-vacation",
    ADD_VACATION_INTIMATION: BASE_URLS.BASE_URL + "staff-quarter-vacation/add-vacation-intimation",
    VACATION_INTIMATION: BASE_URLS.BASE_URL + "staff-quarter-vacation/vacation-intimation",
    VACATION_HISTORY: BASE_URLS.BASE_URL + "staff-quarter-vacation/vacation-history",
    GET_VACATION_INTIMATION: BASE_URLS.BASE_URL + "staff-quarter-vacation/get-vacation-intimation",
    GET_ADMIN_VACATION_INTIMATIONS: BASE_URLS.BASE_URL + "staff-quarter-vacation/get-all-vacation-intimations",
    GET_PENDING_VACATION_REQUESTS: BASE_URLS.BASE_URL + "staff-quarter-vacation/pending-requests",
    APPROVE_REJECT_VACATION: BASE_URLS.BASE_URL + "staff-quarter-vacation/approve-reject",
    GENERATE_VACATION_LETTER: BASE_URLS.BASE_URL + "staff-quarter-vacation/generate-vacation-letter",
    DOWNLOAD_VACATION_LETTER_BY_ID: BASE_URLS.BASE_URL + "staff-quarter-vacation/:id/download-letter",
    VACATION_LETTER_DATA: BASE_URLS.BASE_URL + "staff-quarters-letters/vacation-letter/data",
    INVENTORY_SUMMARY: BASE_URLS.BASE_URL + "staff-quarters-inventory/count-summary",
    CREATE_FLAT: BASE_URLS.BASE_URL + "staff-quarters-inventory/flat",
    GET_ALL_FLATS: BASE_URLS.BASE_URL + "staff-quarters-inventory/get-all-flats",
    GET_OCCUPATION_WITHDRAWAL_LIST: BASE_URLS.BASE_URL + "staff-quarters-occupation/get-occupation-withdrawal-list",
    UPLOAD_DECLARATION_SIGNATURE: BASE_URLS.BASE_URL + "staff-quarters-occupation/upload-declaration-signature",
    PENDING_APPROVALS: BASE_URLS.BASE_URL + "staff-quarters-occupation/pending-approvals",
    GET_PRIORITY_LIST: BASE_URLS.BASE_URL + "staff-quarters/priority-list",
    LOCATIONS: BASE_URLS.BASE_URL + "staff-quarters/locations",
    QUARTER_TYPES: BASE_URLS.BASE_URL + "staff-quarters/quarter-types",
    POOLS: BASE_URLS.BASE_URL + "staff-quarters/pools",
    GENERATE_WILLINGNESS: BASE_URLS.BASE_URL + "staff-quarters/generate-willingness",
    CONFIRM_WILLINGNESS: BASE_URLS.BASE_URL + "staff-quarters/confirm-willingness",
    ALLOT_FLAT: BASE_URLS.BASE_URL + "staff-quarters-inventory/flat/",
    EXPORT_PRIORITY_LIST: BASE_URLS.BASE_URL + "staff-quarters/export/priority-list",
    EXPORT_OCCUPANCY_REPORT: BASE_URLS.BASE_URL + "staff-quarters/export/occupancy-report",
    PROCESS_WILLINGNESS_APPROVAL: BASE_URLS.BASE_URL + "staff-quarters/process-willingness-approval",
    MY_ALLOTMENTS: BASE_URLS.BASE_URL + "staff-quarters/my-allotments",
    PENDING_WILLINGNESS_REQUESTS: BASE_URLS.BASE_URL + "staff-quarters/pending-willingness-requests",
    OCCUPANCY_HISTORY: BASE_URLS.BASE_URL + "staff-quarters-inventory/occupancy-history",
    ALL_ALLOTMENTS: BASE_URLS.BASE_URL + "staff-quarters/all-allotments",
    ALL_WILLINGNESS: BASE_URLS.BASE_URL + "staff-quarters/all-willingness",
    APPROVAL_CONFIG: BASE_URLS.BASE_URL + "staff-quarters/approval-config",
    WILLINGNESS_APPROVERS: BASE_URLS.BASE_URL + "staff-quarters/willingness/approvers",
    REGISTRATION_APPROVERS: BASE_URLS.BASE_URL + "staff-quarters/registration/approvers",
    APPROVAL_CONFIG_POOL: BASE_URLS.BASE_URL + "staff-quarters/approval-config/pool",
    LOCATION_APPROVERS: BASE_URLS.BASE_URL + "staff-quarters/location/approvers",
    PREFERRED_LOCATIONS: BASE_URLS.BASE_URL + "staff-quarters/preferred-locations",
    UPDATE_POOL_TYPE: BASE_URLS.BASE_URL + "staff-quarters-inventory/flat/update-pool-type",
    FINANCE_PENDING_APPROVALS: BASE_URLS.BASE_URL + "staff-quarter-finance/pending-approvals",
    FINANCE_APPROVE_REJECT: BASE_URLS.BASE_URL + "staff-quarter-finance/approve-reject",
    LICENSE_TYPES: BASE_URLS.BASE_URL + "staff-quarter-finance/license-types",
    GENERATE_ALLOTMENT_LETTER: BASE_URLS.BASE_URL + "staff-quarters-occupation/generate-allotment-letter",
    UPDATE_LOCATION: BASE_URLS.BASE_URL + "staff-quarters/update-location",
    ADD_UPDATE_APPROVER: BASE_URLS.BASE_URL + "staff-quarters/add-update-approver",
    OCCUPATION_ADD_UPDATE_APPROVER: BASE_URLS.BASE_URL + "staff-quarters-occupation/add-update-approver",
    VACATION_ADD_UPDATE_APPROVER: BASE_URLS.BASE_URL + "staff-quarter-vacation/add-update-approver",
    GET_VACATION_INTIMATION_DATA: BASE_URLS.BASE_URL + "staff-quarter-vacation/get-vacation-intimation-data",
    CURRENT_PENDING_REQUESTS: BASE_URLS.BASE_URL + "staff-quarters/current-pending-requests",
    SUBMIT_UNWILLINGNESS: BASE_URLS.BASE_URL + "staff-quarters/submit-unwillingness",
    PENDING_UNWILLINGNESS_REQUESTS: BASE_URLS.BASE_URL + "staff-quarters/pending-unwillingness-requests",
    PROCESS_UNWILLINGNESS_APPROVAL: BASE_URLS.BASE_URL + "staff-quarters/process-unwillingness-approval",
  },
  STAFF_QUARTERS_LETTERS: {
    GET_TEMPLATE: (type: string) => `${BASE_URLS.BASE_URL}staff-quarters-letters/templates/${type}`,
    SAVE_TEMPLATE: (type: string) => `${BASE_URLS.BASE_URL}staff-quarters-letters/templates/${type}`,
    RESET_TEMPLATE: (type: string) => `${BASE_URLS.BASE_URL}staff-quarters-letters/templates/${type}/reset`,
    ALLOTMENT_DATA: BASE_URLS.BASE_URL + "staff-quarters-letters/allotment-letter/data",
    ALLOTMENT_DOWNLOAD: BASE_URLS.BASE_URL + "staff-quarters-letters/allotment-letter/download",
  },
  STAFF_QUARTERS_MUTUAL_EXCHANGE: {
    ADMIN_REQUESTS: BASE_URLS.BASE_URL + "staff-quarters-mutual-exchange/admin/requests",
    EMPLOYEE_EXCHANGES: BASE_URLS.BASE_URL + "staff-quarters-mutual-exchange/employee-exchanges",
    EMPLOYEE_QUARTER_INFO: BASE_URLS.BASE_URL + "staff-quarters-mutual-exchange/employee-quarter-info",
    CREATE: BASE_URLS.BASE_URL + "staff-quarters-mutual-exchange/create",
    FIND_ALL: BASE_URLS.BASE_URL + "staff-quarters-mutual-exchange/find-all",
    PENDING_APPROVALS: BASE_URLS.BASE_URL + "staff-quarters-mutual-exchange/pending-approvals",
    APPROVE_REJECT: BASE_URLS.BASE_URL + "staff-quarters-mutual-exchange/approve-reject",
  },
  SV4_CARD: {
    FIND_ALL: BASE_URLS.BASE_URL + "sap-sv4-card/request/find-all",
    SYNC: BASE_URLS.BASE_URL + "sap-sv4-card/sync",
    GET_REASON: BASE_URLS.BASE_URL + "sap-sv4-card/get-reason-to-apply-sap",
    CREATE: BASE_URLS.BASE_URL + "sap-sv4-card/request/create-or-update",
    FIND_ONE: BASE_URLS.BASE_URL + "sap-sv4-card/request/find-one",
    APPROVE_REJECT: BASE_URLS.BASE_URL + "sap-sv4-card/request/approve_reject_action",
  },
  SELF_TRANSFER: {
    TRANSFER_GROUNDS: BASE_URLS.BASE_URL + "sap-self-transfer/transfer-grounds",
    REASON_FOR_TRANSFER: BASE_URLS.BASE_URL + "sap-self-transfer/reason-for-transfer",
    TRANSFER_PERIOD: BASE_URLS.BASE_URL + "sap-self-transfer/transfer-period",
    HOD_LIST: BASE_URLS.BASE_URL + "sap-self-transfer/hod-list",
    TRANSFER_UNDER_LIST: BASE_URLS.BASE_URL + "sap-self-transfer/transfer-under-list",
    FORM_PREFILL: BASE_URLS.BASE_URL + "sap-self-transfer/form-prefill",
    CREATE: BASE_URLS.BASE_URL + "sap-self-transfer/create",
    ALL: BASE_URLS.BASE_URL + "sap-self-transfer/all",
    DETAILS: BASE_URLS.BASE_URL + "sap-self-transfer/details",
    APPROVE_REJECT: BASE_URLS.BASE_URL + "sap-self-transfer/approve-reject",
    SYNC: BASE_URLS.BASE_URL + "sap-self-transfer/sync",
  },
  MISC: {
    HOLIDAYS: BASE_URLS.BASE_URL + "misc/holidays",
    GET_EMPLOYEE_DATES: BASE_URLS.BASE_URL + "misc/get-employee-dates",
    SYNC_HOLIDAY_LIST: BASE_URLS.BASE_URL + "misc/get-holiday-list/",
    UPDATE_SPLASH_SCREEN: BASE_URLS.BASE_URL + "misc/update-splash-screen",
    GET_SPLASH_SCREEN: BASE_URLS.BASE_URL + "misc/splash-screen",
  },

  DAR: {
    // All Cases List
    LIST: BASE_URLS.BASE_URL + "dar/list",
    FIND_ONE: BASE_URLS.BASE_URL + "dar/find-one",

    // Options
    OPTIONS_DAR_TYPES: BASE_URLS.BASE_URL + "dar/options/dar-types",
    OPTIONS_CASE_TYPES: BASE_URLS.BASE_URL + "dar/options/case-types",
    OPTIONS_ROLE_TYPES: BASE_URLS.BASE_URL + "dar/options/role-types",
    OPTIONS_DEPARTMENTS: BASE_URLS.BASE_URL + "dar/options/departments",
    NODAL_LIST: BASE_URLS.BASE_URL + "dar/options/nodal-list",
    HR_AUDITOR_LIST: BASE_URLS.BASE_URL + "dar/options/hr-auditor-list",
    OPTIONS_CHARGES: BASE_URLS.BASE_URL + "dar/charges/list",

    // Role Management
    ROLES_CURRENT_ASSIGNMENTS: BASE_URLS.BASE_URL + "dar/roles/current-assignments",
    ROLES_ASSIGN: BASE_URLS.BASE_URL + "dar/roles/assign",
    ROLES_USER_STATUS: BASE_URLS.BASE_URL + "dar/roles/user-status",

    // Contemplated Stage
    CONTEMPLATED_CREATE: BASE_URLS.BASE_URL + "dar/contemplated/create",
    CONTEMPLATED_FIND_ONE: BASE_URLS.BASE_URL + "dar/contemplated/find-one",
    CONTEMPLATED_UPDATE: BASE_URLS.BASE_URL + "dar/contemplated/update",
    CONTEMPLATED_BYPASS: BASE_URLS.BASE_URL + "dar/contemplated/bypass",
    CONTEMPLATED_LIST: BASE_URLS.BASE_URL + "dar/contemplated/list",

    // Pending Stage
    PENDING_CREATE: BASE_URLS.BASE_URL + "dar/pending/create",
    PENDING_UPDATE: BASE_URLS.BASE_URL + "dar/pending/update",
    PENDING_UPLOAD: BASE_URLS.BASE_URL + "dar/pending/upload",
    PENDING_EVALUATE_DEFENSE: BASE_URLS.BASE_URL + "dar/pending/evaluate-defense",
    PENDING_FIND_ONE: BASE_URLS.BASE_URL + "dar/pending/find-one",
    PENDING_LIST: BASE_URLS.BASE_URL + "dar/pending/list",

    // Closed Stage
    CLOSED_CREATE: BASE_URLS.BASE_URL + "dar/closed/create",
    CLOSED_UPDATE: BASE_URLS.BASE_URL + "dar/closed/update",
    CLOSED_UPLOAD_CORRIGENDUM: BASE_URLS.BASE_URL + "dar/closed/upload-corrigendum",
    CLOSED_FIND_ONE: BASE_URLS.BASE_URL + "dar/closed/find-one",
    CLOSED_LIST: BASE_URLS.BASE_URL + "dar/closed/list",

    // Appeal Stage
    APPEAL_CREATE: BASE_URLS.BASE_URL + "dar/appeal/create",
    APPEAL_UPDATE: BASE_URLS.BASE_URL + "dar/appeal/update",
    APPEAL_UPLOAD_ORDER: BASE_URLS.BASE_URL + "dar/appeal/upload-order",
    APPEAL_FIND_ONE: BASE_URLS.BASE_URL + "dar/appeal/find-one",
    APPEAL_LIST: BASE_URLS.BASE_URL + "dar/appeal/list",

    // Suspension Stage
    SUSPENSION_CREATE: BASE_URLS.BASE_URL + "dar/suspension/create",
    SUSPENSION_UPDATE: BASE_URLS.BASE_URL + "dar/suspension/update",
    SUSPENSION_UPLOAD_CORRIGENDUM: BASE_URLS.BASE_URL + "dar/suspension/upload-corrigendum",
    SUSPENSION_CLOSE: BASE_URLS.BASE_URL + "dar/suspension/close",
    SUSPENSION_FIND_ONE: BASE_URLS.BASE_URL + "dar/suspension/find-one",
    SUSPENSION_LIST: BASE_URLS.BASE_URL + "dar/suspension/list",

    // SAP Employee Master Fetch
    SAP_EMPLOYEE_FETCH: BASE_URLS.BASE_URL + "sap/employee/fetch",

    // Reports
    REPORTS_CASE_REGISTER: BASE_URLS.BASE_URL + "dar/reports/case-register",
    REPORTS_CASE_SUMMARY: BASE_URLS.BASE_URL + "dar/reports/case-summary",
    REPORTS_DA_ASSIGNMENT: BASE_URLS.BASE_URL + "dar/reports/da-assignment",
  },

  PROMOTION: {
    INITIATE: BASE_URLS.BASE_URL + "promotion/initiate",
    PAY_SCALE_GRADE_MASTER: BASE_URLS.BASE_URL + "promotion/pay-scale-grade-master",
    LIST: BASE_URLS.BASE_URL + "promotion/list",
    ELIGIBLE_LIST: BASE_URLS.BASE_URL + "promotion/eligible-list",
    ELIGIBLE_SERVICE_LIST: BASE_URLS.BASE_URL + "promotion/eligible-service-list",
    DOWNLOAD_ELIGIBLE_SERVICE_LIST: BASE_URLS.BASE_URL + "promotion/download-eligible-service-list",
    ELIGIBLE_APAR_LIST: BASE_URLS.BASE_URL + "promotion/eligible-apar-list",
    ELIGIBLE_DAR_LIST: BASE_URLS.BASE_URL + "promotion/eligible-dar-list",
    ELIGIBLE_VIGILANCE_LIST: BASE_URLS.BASE_URL + "promotion/eligible-vigilance-list",
    ELIGIBLE_DPC: BASE_URLS.BASE_URL + "promotion/eligible-dpc",
    CALCULATE_SERVICE: BASE_URLS.BASE_URL + "promotion/calculate-service",
    APAR_SCORES: BASE_URLS.BASE_URL + "promotion/apar-scores",
    DAR_CLEARANCE: BASE_URLS.BASE_URL + "promotion/dar-clearance",
    VIGILANCE_CLEARANCE: BASE_URLS.BASE_URL + "promotion/vigilance-clearance",
    RUN_ALL_CHECKS: BASE_URLS.BASE_URL + "promotion/run-all-checks",
    DPC_REVIEW: BASE_URLS.BASE_URL + "promotion/dpc-review",
    GENERATE_OFFICE_ORDER: BASE_URLS.BASE_URL + "promotion/generate-office-order",
    APPROVE: BASE_URLS.BASE_URL + "promotion/approve",
    CYCLES: BASE_URLS.BASE_URL + "promotion/cycles",
    PROMOTED_COUNTS: BASE_URLS.BASE_URL + "promotion/promoted-counts",
    INCLUDE_ELIGIBLE: BASE_URLS.BASE_URL + "promotion/include-eligible",
    EVALUATE_TWO_STAGE: BASE_URLS.BASE_URL + "promotion/evaluate-two-stage",
    SEARCH_EMPLOYEE: BASE_URLS.BASE_URL + "promotion/search-employee",
    EMPLOYEE_BY_NUMBER: BASE_URLS.BASE_URL + "promotion/employee/",
  },

  PROBATION: {
    EMPLOYEE_TYPES: BASE_URLS.BASE_URL + "confirmation/employee-types",
    TRUNCATE: BASE_URLS.BASE_URL + "confirmation/truncate",
    CYCLES: BASE_URLS.BASE_URL + "confirmation/cycles",
    GENERATE_OFFICE_ORDER: BASE_URLS.BASE_URL + "confirmation/generate-office-order",
    APPROVE: BASE_URLS.BASE_URL + "confirmation/approve",
    SUBMIT_COMMITTEE_REVIEW: BASE_URLS.BASE_URL + "confirmation/submit-committee-review",
    ELIGIBLE_LIST: BASE_URLS.BASE_URL + "confirmation/eligible-list",
    RUN_CLEARANCES: BASE_URLS.BASE_URL + "confirmation/run-clearances",
    CALCULATE_PROBATION: BASE_URLS.BASE_URL + "confirmation/calculate-probation",
    INITIATE: BASE_URLS.BASE_URL + "confirmation/initiate",
    PVR_CLEARED: BASE_URLS.BASE_URL + "confirmation/pvr-cleared",
    CALCULATED_EXCLUDING_LIST_A_B: BASE_URLS.BASE_URL + "confirmation/calculated-excluding-list-a-b",
    SET_PVR_STATUS: BASE_URLS.BASE_URL + "confirmation/set-pvr-status",
    WR_SUITABLE: BASE_URLS.BASE_URL + "confirmation/wr-suitable",
    SET_DAR_STATUS: BASE_URLS.BASE_URL + "confirmation/set-dar-status",
    UPDATE_VIGILANCE_STATUS: BASE_URLS.BASE_URL + "confirmation/update-vigilance-status",
    SET_VIGILANCE_STATUS: BASE_URLS.BASE_URL + "confirmation/set-vigilance-status",
    SET_VIGILANCE_CLEARED_TO_ELIGIBLE: BASE_URLS.BASE_URL + "confirmation/set-vigilance-cleared-to-eligible",
    VIGILANCE_CLEARED: BASE_URLS.BASE_URL + "confirmation/vigilance-cleared",
    COMMITTEE_SUITABLE_CANDIDATES: BASE_URLS.BASE_URL + "confirmation/committee-suitable-candidates",
    OFFICE_ORDER_DATA: BASE_URLS.BASE_URL + "confirmation/office-order-data",
    OFFICE_ORDER_HTML: BASE_URLS.BASE_URL + "confirmation/office-order-html",
    FILL_OFFICE_ORDER: BASE_URLS.BASE_URL + "confirmation/fill-office-order",
    ALL_LISTS_SUMMARY: BASE_URLS.BASE_URL + "confirmation/all-lists-summary",
    CANDIDATES: BASE_URLS.BASE_URL + "confirmation/candidates",
    UPLOAD_PVR: BASE_URLS.BASE_URL + "confirmation/upload-pvr",
    WR_GRADING: BASE_URLS.BASE_URL + "confirmation/wr-grading",
    UPLOAD_WR: BASE_URLS.BASE_URL + "confirmation/upload-wr",
    UPLOAD_DAR: BASE_URLS.BASE_URL + "confirmation/upload-dar",
    UPLOAD_VIGILANCE: BASE_URLS.BASE_URL + "confirmation/upload-vigilance",
    GENERATE_SINGLE_OFFICE_ORDER_PDF: BASE_URLS.BASE_URL + "confirmation/generate-single-office-order-pdf",
    GENERATE_OFFICE_ORDER_PDF: BASE_URLS.BASE_URL + "confirmation/generate-office-order-pdf",
    EXCLUDE: BASE_URLS.BASE_URL + "confirmation/exclude",
    DOWNLOAD_APPRAISAL_PERIODS: BASE_URLS.BASE_URL + "confirmation/download-appraisal-periods",
    INCLUDE_ELIGIBLE: BASE_URLS.BASE_URL + "promotion/include-eligible",
  },

  SAP_AUTHORIZATION: {
    MASTER_FIND_ALL: BASE_URLS.BASE_URL + "authorization-form/master/find-all",
    MASTER_FIND_ONE: BASE_URLS.BASE_URL + "authorization-form/master/find-one",
    FIND_ALL: BASE_URLS.BASE_URL + "authorization-form/request/find-all",
    FIND_ONE: BASE_URLS.BASE_URL + "authorization-form/request/find-one",
    FIND_ONE_BY_REF: BASE_URLS.BASE_URL + "authorization-form/request/find-one-by-ref-number",
    CREATE_UPDATE: BASE_URLS.BASE_URL + "authorization-form/request/create-or-update",
    APPROVE_REJECT: BASE_URLS.BASE_URL + "authorization-form/request/approve-reject-action",
    DELETE_DRAFT: BASE_URLS.BASE_URL + "authorization-form/request/delete-draft",
    SYNC: BASE_URLS.BASE_URL + "sap-auth-form/sync-requests-by-date",
  },
  SAP_LOAN_REQUESTS: {
    SYNC_BY_EMPLOYEE: BASE_URLS.BASE_URL + "sap-loan-requests/sync-by-employee",
  },

  E_ATTESTATION: {
    MASTER_CREATE_OR_UPDATE: BASE_URLS.BASE_URL + "e-attestation/master/create-or-update",
    MASTER_TOGGLE_STATUS: BASE_URLS.BASE_URL + "e-attestation/master/toggle-status",
    MASTER_DROPDOWN: BASE_URLS.BASE_URL + "e-attestation/master",
    MASTER_LIST: BASE_URLS.BASE_URL + "e-attestation/master/list",
    APPROVER_CREATE_OR_UPDATE: BASE_URLS.BASE_URL + "e-attestation/approver/create-or-update",
    APPROVER_TOGGLE_STATUS: BASE_URLS.BASE_URL + "e-attestation/approver/toggle-status",
    APPROVER_LIST: BASE_URLS.BASE_URL + "e-attestation/approver/list",
    REQUEST_CREATE_OR_UPDATE: BASE_URLS.BASE_URL + "e-attestation/request/create-or-update",
    REQUEST_FIND_ALL: BASE_URLS.BASE_URL + "e-attestation/request/find-all",
    REQUEST_FIND_ONE: BASE_URLS.BASE_URL + "e-attestation/request/find-one",
    REQUEST_APPROVE_REJECT: BASE_URLS.BASE_URL + "e-attestation/request/approve-reject",
    REQUEST_DELETE: BASE_URLS.BASE_URL + "e-attestation/request/delete",
    TYPES_MODEL: BASE_URLS.BASE_URL + "e-attestation/types-model",
  },

  IT_DECLARATION: {
    REQUEST_TYPES_SYNC: BASE_URLS.BASE_URL + "it-declaration/request-types",
    S80_SYNC: BASE_URLS.BASE_URL + "it-declaration/s80",
    S80C_SYNC: BASE_URLS.BASE_URL + "it-declaration/s80c",
    SUB_TYPES: BASE_URLS.BASE_URL + "it-declaration/sub-types",
    PROPERTY_TYPES: BASE_URLS.BASE_URL + "it-declaration/property-types",
    REQUEST_PHASE: BASE_URLS.BASE_URL + "it-declaration/request-phase",
    REQUEST_STATUS: BASE_URLS.BASE_URL + "it-declaration/request-status",
    FIND_ALL: BASE_URLS.BASE_URL + "it-declaration/find-all",
    FIND_ONE: BASE_URLS.BASE_URL + "it-declaration/find-one",
    CONFIGURATION_SETS: BASE_URLS.BASE_URL + "it-declaration/configuration-sets",
    CONTENT_SETS: BASE_URLS.BASE_URL + "it-declaration/content-sets",
    DOWNLOAD_FORM_12BB: BASE_URLS.BASE_URL + "it-declaration/download-form-12bb",
    CREATE_OR_UPDATE: BASE_URLS.BASE_URL + "it-declaration/create-or-update",
    SYNC_REQUEST: BASE_URLS.BASE_URL + "it-declaration/sync-request",
    GET_ATTACHMENTS: BASE_URLS.BASE_URL + "it-declaration/get-attachments",
  },

  APPRAISAL: {
    DOCUMENT_LIST: BASE_URLS.BASE_URL + "appraisal/document-list",
    DOCUMENT_DETAILS: BASE_URLS.BASE_URL + "appraisal/document-details",
    CATEGORY_GROUP: BASE_URLS.BASE_URL + "appraisal/category-group",
    TEMPLATE: BASE_URLS.BASE_URL + "appraisal/template",
    EMPLOYEES: BASE_URLS.BASE_URL + "appraisal/employees",
    PRINT: BASE_URLS.BASE_URL + "appraisal/print",
    DISPLAY: BASE_URLS.BASE_URL + "appraisal/display",
    DOWNLOAD: BASE_URLS.BASE_URL + "appraisal/download",
    STATUS: BASE_URLS.BASE_URL + "appraisal/status",
    EMPLOYEE_CHANNEL: BASE_URLS.BASE_URL + "appraisal/employee-channel",
  },

  MANAGER_SELF_SERVICE: BASE_URLS.BASE_URL + "employee/manager-self-service",
};

